export default {
  toggled: {
    calibration: false,
    customErrorInput: true,
  },
};
